import React from 'react'
import { isMobile } from '../../../shared/custom-ant-d'
import { FilePdfOutlined } from '@ant-design/icons';
import { List, Skeleton, Button } from 'antd';

const BookList = (props) => {
  const { employeeHandbooks, listLoading, setSelectedHandbook
  } = props;

  return (
    <Skeleton loading={listLoading} active>
      <>
        {
          (employeeHandbooks != null) ?
            (
              <>
                {
                  (isMobile) ?
                    (
                      <List
                        dataSource={employeeHandbooks}
                        grid={{
                          column: 1,
                        }}
                        renderItem={item => (
                          <List.Item>
                            <List.Item.Meta
                              avatar={<FilePdfOutlined />}
                              title={
                                <Button type='link'
                                  onClick={() => {
                                    setSelectedHandbook(item)
                                  }}
                                >{item.documentFriendlyName}</Button>
                              }
                            />
                          </List.Item>
                        )}
                      />
                    ) :
                    (
                      <List
                        dataSource={employeeHandbooks}
                        grid={{
                          column: 3,
                        }}
                        renderItem={item => (
                          <List.Item>
                            <List.Item.Meta
                              avatar={<FilePdfOutlined />}
                              title={
                                <Button type='link'
                                  onClick={() => {
                                    setSelectedHandbook(null)
                                    setSelectedHandbook(item)
                                  }}
                                >{item.documentFriendlyName}</Button>
                              }
                            />
                          </List.Item>
                        )}
                      />
                    )
                }
              </>
            ) : (<></>)
        }
      </>
    </Skeleton>
  )
}
export default BookList
